import React, { useRef } from 'react'
import './startupfeatures.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { FaArrowRightLong } from "react-icons/fa6";

function Features() {
    const sliderRef = useRef(null);

    const settings = {
        rows: 2,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        swipe: false,
        draggable: false,
        responsive: [
            {
                breakpoint: 1280, // For screens ≤ 1280px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 780, // For screens ≤ 780px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    const startupFeaturesInfo = [
        {
            id: 0,
            icon: require('../../images/startupfeature1.png'),
            title: "Niche or Specific Tech Consultation by Lead Engineer",
            text: "Whether you're working in AI, AR, or a niche field, let's tackle your technical challenges and uncover opportunities. You'll get tailored advice to ensure you're using the right tools and strategies for your product goals.",

        },
        {
            id: 1,
            icon: require('../../images/startupfeature2.png'),
            title: "Technology Roadmap Consulting with our Tech Team",
            text: "Got a big vision? We’ll work with you to develop a clear, realistic, step-by-step plan that aligns with your budget, timeline, and goals. This ensures you can bring your idea to life without wasting time, resources, or energy, setting you up for success.",

        },
        {
            id: 2,
            icon: require('../../images/startupfeature3.png'),
            title: "Architecture & Scalability Audits from our team",
            text: "We’ll give your system a thorough checkup to identify performance or security bottlenecks early on. This proactive approach ensures you can scale seamlessly and confidently, without worrying about unexpected issues or surprises disrupting your progress.",

        },
        {
            id: 3,
            icon: require('../../images/startupfeature4.png'),
            title: "Ongoing Product Feature Validation",
            text: "Not sure which features to build next? We’ll guide you in carefully prioritizing the features that truly matter most to your users, ensuring you stay focused, lean, and highly effective in delivering meaningful value where it counts the most.",

        },
        {
            id: 4,
            icon: require('../../images/startupfeature5.png'),
            title: "Domain-Specific Best Practices Documentation",
            text: "Not sure which features to build next? We’ll help you analyze your users' needs and prioritize the features that truly matter. This ensures you stay focused, lean, and effective in delivering meaningful value that aligns with your goals and satisfies user expectations.",

        },
        {
            id: 5,
            icon: require('../../images/startupfeature6.png'),
            title: "Mentorship-Style Office Hours",
            text: "Have questions or need guidance? Let’s set up regular chat sessions to connect and collaborate. These sessions are your time to bounce ideas, brainstorm solutions, or tackle product challenges. Whether refining your vision or planning next steps, we are here to help.",

        },
        {
            id: 6,
            icon: require('../../images/startupfeature1.png'),
            title: "Niche or Specific Tech Consultation by Lead Engineer",
            text: "Whether you're working in AI, AR, or a niche field, let's tackle your technical challenges and uncover opportunities. You'll get tailored advice to ensure you're using the right tools and strategies for your product goals.",

        },
        {
            id: 7,
            icon: require('../../images/startupfeature2.png'),
            title: "Technology Roadmap Consulting with our Tech Team",
            text: "Got a big vision? We’ll work with you to develop a clear, realistic, step-by-step plan that aligns with your budget, timeline, and goals. This ensures you can bring your idea to life without wasting time, resources, or energy, setting you up for success.",

        },
        {
            id: 8,
            icon: require('../../images/startupfeature2.png'),
            title: "Technology Roadmap Consulting with our Tech Team",
            text: "Got a big vision? We’ll work with you to develop a clear, realistic, step-by-step plan that aligns with your budget, timeline, and goals. This ensures you can bring your idea to life without wasting time, resources, or energy, setting you up for success.",

        },
        {
            id: 9,
            icon: require('../../images/startupfeature2.png'),
            title: "Technology Roadmap Consulting with our Tech Team",
            text: "Got a big vision? We’ll work with you to develop a clear, realistic, step-by-step plan that aligns with your budget, timeline, and goals. This ensures you can bring your idea to life without wasting time, resources, or energy, setting you up for success.",

        },
        {
            id: 10,
            icon: require('../../images/startupfeature2.png'),
            title: "Technology Roadmap Consulting with our Tech Team",
            text: "Got a big vision? We’ll work with you to develop a clear, realistic, step-by-step plan that aligns with your budget, timeline, and goals. This ensures you can bring your idea to life without wasting time, resources, or energy, setting you up for success.",

        }
    ]
    return (
        <div className='features-main' id='features'>
            <div className="A-title" data-aos="fade-up" >
                <span>Features</span>
                <h1>Our Valued Partners in Success</h1>
                <p className='title-text'>Ready for your next development cycle? We focus on crafting thoughtful solutions that move as fast as your vision.</p>
            </div>
            <Slider {...settings} ref={sliderRef} >
                {
                    startupFeaturesInfo.map((_featuresInfo) => (
                        <div className='featurebox' key={_featuresInfo.id} data-aos="fade-up" data-aos-duration="1000">
                            <img src={_featuresInfo.icon} alt="" />
                            <h4>{_featuresInfo.title}</h4>
                            <p>{_featuresInfo.text}</p>
                        </div>
                    ))
                }
            </Slider>
            <div className="bottom-buttons">
                <a href="https://arttteo.com/contact">
                    <button className="estimation-button whitebutton">
                        <p>Get Your Free Consultation</p>
                        <div className="arrow-circle">
                            <FaArrowRightLong />
                        </div>
                    </button>
                </a>
                <div className="sl-buttons">
                    <button className="custom-arrow" onClick={() => sliderRef.current.slickPrev()}>
                        <FaArrowLeft />
                    </button>
                    <button className="custom-arrow" onClick={() => sliderRef.current.slickNext()}>
                        <FaArrowRight />
                    </button>
                </div>

            </div>

        </div>
    )
}

export default Features